import { Component, computed, inject, input, OnInit } from '@angular/core';
import { Product, TextNodeType, translateTariffClasses } from '@mwe/models';
import { TranslateService } from '@ngx-translate/core';
import { HeadlineService } from '../../../headline/headline.service';
import { ProductTariffCardTemplateComponent } from '../../tariff-card-template/product-tariff-card-template.component';
import { HeadlineComponent } from '../../../headline/headline.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { InfoboxComponent } from '../../../infobox/infobox.component';

@Component({
  selector: 'mwe-tariff-card-waerme',
  templateUrl: './tariff-card-waerme.component.html',
  providers: [HeadlineService],
  imports: [ProductTariffCardTemplateComponent, HeadlineComponent, NgClass, AsyncPipe, InfoboxComponent],
})
export class TariffCardWaermeComponent implements OnInit {
  product = input.required<Product>();
  headlineReference = input<TextNodeType>('h3');
  hideNoTariffsMessage = input<boolean>(false);
  hasTariffClasses = computed<boolean>(() => this.product().tariffClasses?.filter(e => e).length > 0); // we might get '' as a tariff class
  tariffClasses = computed<Promise<string[]>>(() => {
    return translateTariffClasses(this.product().category, this.product().tariffClasses, this.translateService);
  });

  headlineService = inject(HeadlineService);
  private translateService = inject(TranslateService);

  ngOnInit() {
    this.headlineService.setReferenceHeadline(this.headlineReference());
  }
}
